import { useSearchParams } from "react-router-dom";
import { Button, PasswordInput } from "@mantine/core";
import { useForm, isNotEmpty, matchesField } from "@mantine/form";
import { useNavigate } from "react-router-dom";
import { errorNotification } from "@/helpers/notifications";
import { AuthApi } from "@/api/auth.api";

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      newPassword: "",
      repeatPassword: "",
    },
    validate: {
      newPassword: isNotEmpty("Obavezno polje"),
      repeatPassword: matchesField("newPassword", "Lozinke se ne podudaraju"),
    },
  });

  const handleReset = async (values: typeof form.values) => {
    if (!token) {
      errorNotification({
        message:
          "Molimo otvorite link za kreiranje nove lozinke iz dobivenog mail-a",
      });
      return;
    }
    const data = {
      token,
      password: values.newPassword,
    };
    const res = await AuthApi.resetPassword(data);
    if (res.isSuccessful) {
      navigate("/password-reset-success");
    } else {
      errorNotification({
        message: res?.message ?? "Molimo pokušajte ponovno.",
      });
    }
  };

  return (
    <div className="forgotten-password-container">
      <form
        className="forgotten-password-card"
        onSubmit={form.onSubmit(handleReset)}
      >
        <div className="forgotten-password-content">
          <div className="forgotten-password-title">Kreiraj novu lozinku</div>
          <div className="flex flex-col gap-6">
            <PasswordInput
              className="flex-1"
              classNames={{
                input: "password-input",
              }}
              label="Lozinka"
              placeholder="*********"
              key={form.key("newPassword")}
              {...form.getInputProps("newPassword")}
            />
            <PasswordInput
              className="flex-1"
              classNames={{
                input: "password-input",
              }}
              label="Ponovi novu lozinku"
              placeholder="*********"
              key={form.key("repeatPassword")}
              {...form.getInputProps("repeatPassword")}
            />
          </div>
        </div>
        <div className="forgotten-password-button-container">
          <Button
            type="submit"
            variant="filled"
            color="#004a99"
            radius="xl"
            size="md"
            className="flex-1 !h-[3.25rem]"
          >
            Potvrdi
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
